import { adminCall, adminGet } from '../../../api/adminCall';

export async function getPlatformDeluxeSettings() {
  return adminGet('/api/admin/platform/deluxe');
}

export async function setPlatformDeluxeSettings(payload) {
  const data = await adminCall('/api/admin/platform/deluxe', payload || {});
  if (!data?.success) throw new Error(data?.error || 'Failed to save Deluxe settings');
  return data;
}

export async function testPlatformDeluxeSettings({ environment } = {}) {
  const data = await adminCall('/api/admin/platform/deluxe/test', environment ? { environment } : {});
  if (!data?.success) throw new Error(data?.error || 'Deluxe test failed');
  return data;
}

export async function clearPlatformDeluxeSettings() {
  const data = await adminCall('/api/admin/platform/deluxe/clear');
  if (!data?.success) throw new Error(data?.error || 'Failed to disconnect Deluxe');
  return data;
}

export async function getPlatformDeluxeHostedFormConfig({ environment } = {}) {
  const query = environment ? `?environment=${encodeURIComponent(environment)}` : '';
  return adminGet(`/api/admin/platform/deluxe/hosted-form${query}`);
}
